/**
 * TODO: This file will be deprecated and removed in the future.
 * This HOC will be replaced with `desktop/src/app/hooks/use-is-authenticated.js`.
 *
 * NOTE: This HOC is still in use in the following places and should be migrated to use the new hook:
 * - src/app/components/player/meta/meta.jsx
 * - src/app/components/player/youbora/youbora-data.jsx
 * - desktop/src/app/containers/play-button/details-play-button.js
 * - desktop/src/app/containers/play-button/showpage-play-button.js
 * - desktop/src/app/containers/subscriptions/neon/subscription-voucher-warn.js
 * - desktop/src/app/containers/subscriptions/neon/subscription-repair/index.js
 * - desktop/src/app/containers/subscriptions/neon/welcome-back/index.js
 * - desktop/src/app/hoc/qs-add-to-my-list.js
 * - desktop/src/app/hoc/withPlaybackInfo.js
 */
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { checkIsAuthenticated } from '../lib/auth'

// Higher order component to manage loading screen on mutations
export default compose(
  connect(
    state => ({
      isAuthenticated: checkIsAuthenticated(state) // used to skip account query
    })
  )
)
